import { render, staticRenderFns } from "./ot-project-document-layout.vue?vue&type=template&id=b0e05c62&"
import script from "./ot-project-document-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-project-document-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports